import React from "react";

import {
  XIcon,
  MenuIcon,
  HomeIcon,
  DeviceMobileIcon,
  LocationMarkerIcon,
  MailIcon,
  PhoneIcon,
  ChevronLeftIcon,
} from "@heroicons/react/outline";
import { Link } from "react-router-dom";

export default class NotFound extends React.Component {
  constructor(props) {
    super(props);
    this.state = { isMenu: false };

    // This binding is necessary to make `this` work in the callback
    this.handleMenu = this.handleMenu.bind(this);
  }

  handleMenu() {
    window.scrollTo(0, 0);
    this.setState((prevState) => ({
      isMenu: !prevState.isMenu,
    }));
    document.body.classList.toggle("no-scroll", !this.state.isMenu);
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    document.body.classList.remove("no-scroll");
  }

  render() {
    return (
      <div className="page-home">
        <div className="min-h-screen relative bg-white overflow-hidden">
          <div className="mt-6 mx-6 flex flex-col items-center relative">
            <div className="h-28 w-full max-w-screen-xl flex flex-row">
              <div className="flex flex-col justify-center items-center">
                <a href="/" className="h-full relative z-30">
                  <img
                    className="h-full w-full object-scale-down"
                    src="http://tekn.is/img/logo.webp"
                  />
                </a>
              </div>
              <div className="w-24 ml-6 flex-grow flex flex-col justify-center items-end">
                <button
                  className={
                    "absolute p-6 z-50" +
                    (!this.state.isMenu
                      ? " text-stone-700 hover:bg-stone-900 hover:text-stone-100"
                      : " text-stone-100 hover:bg-stone-100 hover:text-stone-700")
                  }
                  onClick={this.handleMenu}
                >
                  {this.state.isMenu ? (
                    <XIcon className="h-6 w-6" aria-hidden="true" />
                  ) : (
                    <MenuIcon className="h-6 w-6" aria-hidden="true" />
                  )}
                </button>
              </div>
            </div>
            <div className="relative z-30 min-h-[520px] w-full max-w-screen-xl py-32 text-stone-700 flex flex-col gap-4 justify-center">
              <h3 className="font-light"></h3>
              <h1 className="font-light text-4xl md:text-6xl">
                ÞESSI SÍÐA ER <strong className="font-bold">EKKI TIL</strong>
              </h1>
              <h2 className="font-light"></h2>
              <div className="flex flex-col md:flex-row gap-4 mt-4">
                <Link to="/">
                  <button className="w-full md:w-72 h-16 md:text-xl bg-stone-900 text-stone-100 hover:bg-stone-700 flex flex-col items-center justify-center">
                    <ChevronLeftIcon className="h-6 w-6" aria-hidden="true" />
                  </button>
                </Link>
                <a href="#hafdu-samband">
                  <button className="w-full md:w-72 h-16 md:text-lg bg-stone-900 text-stone-100 hover:bg-stone-700">
                    HAFÐU SAMBAND
                  </button>
                </a>
              </div>
            </div>
          </div>
          <svg
            className="absolute z-0 top-0 hidden xl:block 2xl:-translate-y-32"
            viewBox="0 0 100 60"
            xmlns="http://www.w3.org/2000/svg"
          >
            <ellipse
              className="fill-stone-900"
              cx="100"
              cy="70"
              rx="50"
              ry="40"
            />
          </svg>

          <div className="h-80 w-full bg-stone-900 relative z-30">
            <img
              className="h-full w-full object-cover saturate-50"
              src="http://tekn.is/img/notready.jpg"
            ></img>
          </div>

          <div
            id="nav-menu"
            className={
              "transition ease-in-out duration-300 absolute z-30 top-0 h-screen w-screen bg-stone-900 text-stone-100 flex flex-col gap-6 items-center justify-center text-xl sm:text-base lg:text-xl" +
              (!this.state.isMenu ? " translate-x-full" : " translate-x-0")
            }
          >
            <img
              className="h-auto w-72 md:w-96 object-scale-down"
              src="http://tekn.is/img/logo-light.webp"
            />
            <div
              className={
                "transition-opacity ease-in-out delay-300 duration-1000 flex flex-col md:flex-row items-center justify-center " +
                (!this.state.isMenu ? " opacity-0" : " opacity-100")
              }
            >
              <Link to="/" onClick={this.handleMenu}>
                <button className="bg-sky-900 px-12 font-bold p-6">
                  <HomeIcon className="h-6 w-6" aria-hidden="true" />
                </button>
              </Link>
              <Link to="/thjonusta" onClick={this.handleMenu}>
                <button className="hover:text-sky-700 font-bold p-6">
                  ÞJÓNUSTA
                </button>
              </Link>
              <Link to="/verkefni" onClick={this.handleMenu}>
                <button className="hover:text-sky-700 font-bold p-6">
                  VERKEFNI
                </button>
              </Link>
              <Link to="/starfsmenn" onClick={this.handleMenu}>
                <button className="hover:text-sky-700 font-bold p-6">
                  STARFSMENN
                </button>
              </Link>
              <a href="#hafdu-samband" onClick={this.handleMenu}>
                <button className="hover:text-sky-700 font-bold p-6">
                  HAFÐU SAMBAND
                </button>
              </a>
            </div>
          </div>
        </div>
        <div
          id="hafdu-samband"
          className="section-hafdu-samband bg-stone-100 w-full text-stone-700 flex flex-col items-center"
        >
          <div className="px-6 w-full max-w-screen-xl flex flex-col md:flex-row gap-6 py-32 xl:py-48 min-h-[520px]">
            <div className="w-full md:w-1/2 flex flex-col justify-center">
              <h3 className="font-light text-lg">HAFÐU SAMBAND</h3>
              <h1 className="font-light text-4xl">
                <strong className="font-bold">LÁTTU</strong> HEYRA Í ÞÉR
              </h1>
              <div className="flex flex-col md:flex-row gap-4 mt-4">
                <a href="mailto:teknis@tekn.is">
                  <button className="w-full md:w-24 h-16 md:text-lg bg-sky-900 text-stone-100 hover:bg-sky-700 flex flex-col items-center justify-center">
                    <MailIcon className="h-6 w-6" aria-hidden="true" />
                  </button>
                </a>
                <a href="tel:+3545657390">
                  <button className="w-full md:w-24 h-16 md:text-lg bg-sky-900 text-stone-100 hover:bg-sky-700 flex flex-col items-center justify-center">
                    <PhoneIcon className="h-6 w-6" aria-hidden="true" />
                  </button>
                </a>
                <a href="tel:+3548935548">
                  <button className="w-full md:w-24 h-16 md:text-lg bg-sky-900 text-stone-100 hover:bg-sky-700 flex flex-col items-center justify-center">
                    <DeviceMobileIcon className="h-6 w-6" aria-hidden="true" />
                  </button>
                </a>
              </div>
              <div className="hidden md:block">
                <span className="text-xl mt-6 flex flex-row gap-4 items-center">
                  <MailIcon className="h-6 w-6" aria-hidden="true" />{" "}
                  teknis@tekn.is
                </span>
                <span className="text-xl mt-6 flex flex-row gap-4 items-center">
                  <PhoneIcon className="h-6 w-6" aria-hidden="true" /> 565-7390
                </span>
                <span className="text-xl mt-6 flex flex-row gap-4 items-center">
                  <DeviceMobileIcon className="h-6 w-6" aria-hidden="true" />{" "}
                  893-5548
                </span>
              </div>

              <span className="text-xl mt-6 flex flex-row gap-4 items-center">
                <LocationMarkerIcon className="h-6 w-6" aria-hidden="true" />{" "}
                Einhella 8, 221 Hafnarfjörður
              </span>
            </div>
            <div className="w-full md:w-1/2">
              <div className="h-72 md:h-96 bg-stone-200 flex justify-center items-center">
                <iframe
                  className="w-full h-full"
                  frameBorder="0"
                  src="https://en.ja.is/webapi/kort/?lat=64.039296&lon=-21.999660&nz=14.00&layer=map&q=hashid%3Av2nYo"
                ></iframe>
              </div>
            </div>
          </div>
        </div>
        <div className="section-footer bg-stone-800 w-full text-stone-100 flex flex-col items-center">
          <div className="px-6 w-full max-w-screen-xl flex flex-col md:flex-row gap-6 py-32 xl:py-48 min-h-[520px]"></div>
        </div>
      </div>
    );
  }
}
